import styled from 'styled-components';

import mixins from '../mixins';

export default styled.div`
  min-width: 768px;
  max-width: 1200px;
  width: 100vw;
  margin: 0 auto;
  ${({ theme }) => mixins.features.materialOrder.containerPadding(theme)};
`;
